import DeepKeys from '@common/types/deepKeys';

const LANGUAGE_FILE_EN = {
	header: {
		toolbar: {
			report: 'Report',
			certificates: 'Certificates',
			education: 'Education',
			news: 'News',
			gradebook: 'Gradebook',
			market: 'Market',
			appointment: 'Appointment',
			student: 'student',
			emptyVideo: 'Tutorial has not been added yet',
			billing: 'Billing',
		},
	},
	certificates: {
		main: 'Certificates',
		details: 'Details',
		download: 'Download',
		requirements: 'Certificate Requirements',
		finalTestGrade: 'Score for the final test at least 70%',
		homeworkPercent: 'Number of completed homework assignments at least 75%',
		scoreGrade: 'Average score for class work at least 70%',
		overallGrade: 'Average score for homework assignments at least 70%',
		downloadText: 'Download certificate:',
		emptyDataTitle: 'Place for your achievements🏆',
		averageNull:
			'Your certificate will appear here as soon as you complete the program! Good luck💪',
	},
	pwa: {
		push: 'Pwa push',
		installBanner: {
			campus: 'Back to Campus',
			install: 'Install PWA',
			tutorial: 'Watch video tutorial',
		},
	},
	scorm: {
		rotateHint:
			"To complete the task, turn your phone horizontally or open the lesson on your computer — it's more convenient that way 😉",
	},
	market: {
		main: 'Market',
	},
	report: {
		yearsOfStudy: 'Years of study',
		gradeNumber: '{{count}}th grade',
		aboutMe: {
			strengths: 'Strengths',
			personalityQualities: 'Personal qualities',
			interests: 'Interests',
		},
		goals: {
			main: 'Goals',
			specifycResults: 'Specific result',
			continuation: 'Continuation',
			breakeDown: 'Breake down by step how you will achive the goal',
			addSteps: 'Add steps to the goal',
			describeSubGoal: 'Steps to achieve the goal',
		},
		individuality: {
			main: 'Individuality',
			hobbies: 'Hobbies',
			values: 'Values',
			talents: 'Talents',
		},
		achievements: {
			main: 'Achievements',
			academicAchievements: 'Academic achievements',
			mentorSupport: 'Mentor support',
			documents: {
				title: 'Documents',
				subTitle: 'PDF file',
				files: {
					gyms: 'Information About Gyms - Gyms',
					onlineLearning: 'Procedure for Switching to Temporary Online Learning',
					poolRules: 'Pool Visit Rules',
					handbook: 'TIS: Handbook for Students and Parents',
					faq: 'FAQ TIS',
				},
			},
			myEducationPlannerPortfolio: 'My portfolio',
			emptyData: 'New data will be added throughout the year.',
			projects: 'Projects',
			knowledge: 'Knowledge',
			files: {
				one: '{{count}} file',
				few: '{{count}} files',
				many: '{{count}} files',
			},
			tooltip: 'Some information explaining the main purpose of this block',
			addFileModal: {
				title: 'Uploading a file',
				placeholderName: 'Enter the file name',
				placeholderType: 'Achievements from which field',
				selectFile: 'Select file',
				drop: 'Drop file to upload',
				selectOrDrop: 'Select a file or drag and drop here',
			},
		},
	},
	programs: {
		main: 'Programs',
		seeAll: 'See all',
		empty: "You don't have any programs yet",
		name: 'Name',
		lessons: {
			one: '{{count}} lesson',
			few: '{{count}} lessons',
			many: '{{count}} lessons',
			deadlineExpired: 'Deadline expired',
		},
		currentLearningFlow: {
			currentDirection: 'Current direction',
			directionTitle: '{{direction}} · Grade {{grade}} learning path',
			creditsActive: '{{active}} of {{total}} credits active',
			instalmentPlan: 'Current instalment plan',
			nextCharge: 'Next charge: <b>{{date}} · {{amount}}</b>',
		},
	},
	program: {
		teacher: 'Teacher',
		yourProgress: 'Your progress',
		inProgress: 'In progress',
		overview: 'Program Overview',
		checking: 'Under assessment',
		completed: 'Graded',
		rejected: 'Rejected',
		visited: 'Visited',
		planned: 'Planned lessons',
		missed: 'Missed',
		noStatus: 'Status is not selected',
		reviewed: 'Reviewed',
		courseProgress: 'Course progress',
		workOnThePlatform: 'Overall grade',
		missedClasses: 'Missed classes',
		missedLessons: 'Missed lessons',
		workingOff: 'Lessons to be covered with a tutor',
		learnt: 'Practiced lessons',
		courseTextBooks: 'Course textbooks',
		totalLessons: 'Total lessons',
		lessonOpenIn: 'The lesson will open on {{date}}',
		checkingEmptyLessonsTitle: 'Looks like there’s nothing to review yet',
		checkingEmptyLessonsDescription: 'Complete your homework, and it will appear here 😉',
		completedEmptyLessonsTitle: 'No completed lessons yet',
		completedEmptyLessonsDescription:
			"Make sure to finish your lessons and submit them for review. If you've already done so, sit tight while your instructor evaluates them! 😊",
		review: 'Review',
		nonGradedAssignment: 'Non-graded Assignment',
		activeEmptyLessonsTitle: 'No active lessons here.',
		activeEmptyLessonsDescription:
			"It looks like you've already completed all your homework, so keep it up! Or maybe it's not time for the next lessons yet ⌛️",
		resetEmptyLessonsTitle: 'Nothing here.',
		resetEmptyLessonsDescription:
			'It looks like all the lessons are going well on the first try, keep it up!💥',
		certificateToolTip: 'Complete all tasks to download the file',
		certificateDownload: 'Download the certificate',
		professionalPathDownload: 'Professional Path',
		moreLessons: 'More lessons',
	},
	lesson: {
		discoverYourself: 'Lesson Overview',
		nextLesson: 'Next Lesson',
		emptyTeacherComment: 'Comments from the teacher will be displayed in this section',
		emptyDetails: 'This block will display the lesson materials',
		files: 'Files',
		books: 'Books',
		links: 'Helpful links',
		zoomLink: 'Zoom Link',
		zoomId: 'Zoom id',
		zoomAccessCode: 'Zoom access code',
		miroLink: 'Miro Link',
		complete: 'The lesson was successfully passed',
		errorComplete: 'An error occurred while submitting a lesson',
		emptyTitle: 'The lesson will be available soon',
		teacherFeedback: 'Teacher Feedback',
		discussionBoard: 'Discussion Board Link',
		testRules: {
			test: 'Test',
			attention: 'Attention!',
			videoSurveillance: 'Video Surveillance in Progress',
			description:
				'This test is monitored via video surveillance to ensure fairness and transparency.',
			title: 'Test Rules:',
			monitoring: 'Video monitoring is mandatory',
			monitoringDescription: 'throughout the entire test.',
			prohibited: 'Prohibited actions:',
			prohibitedDescription:
				'using external materials, communicating with others, or switching between tabs.',
			timeLimited: 'The test is time-limited',
			timeLimitedDescription: '— do not interrupt it without a valid reason.',
			mustAgree: 'To proceed, you must agree to the rules.',
			disagreeDescription: 'If you do not agree, you will not be able to take the test',
			doNotAgree: 'Do Not Agree',
			agree: 'Agree to the Rules',
		},
		rubric: {
			showMore: 'Show more',
			tableTitle: 'Assessment rubric',
			criteria: 'Criteria',
			mark: 'Mark',
		},
	},
	resources: {
		main: 'Resources',
		new: 'NEW',
		inProcess: 'In process',
		completed: 'Completed',

		titleOrAuthor: 'Book title or author',
		emptySearchTitle: 'There are no results for "{{search}}"',
		emptySearchSubTitle: 'You may have entered an incorrect query. Check the spelling.',
		length: {
			one: '{{count}} book',
			few: '{{count}} books',
			many: '{{count}} books',
		},
		emptyBooksTitle: 'No books have been added yet',
		emptyBooksDescription: 'Stay tuned for more learning resources coming soon!',
		emptyMaterialTitle: 'Materials are not available at the moment',
		emptyMaterialDescription: 'Expect new resources soon!',
	},
	news: {
		main: 'News',
		latest: 'Latest News',
		all: 'All News',
		popularity: 'Popularity',
		wasTheArticleUseful: 'Was the article useful?',
		emptyDataTitle: 'There is no news at the moment',
		emptyDataDescription: 'Stay tuned for an update soon!',
	},
	consultations: {
		main: 'Consultations',
		start: 'Start',
		freeSlot: 'Free slot',
		notEnoughFreeSlots: 'Not enough consecutive free slots',
		chooseSessionDuration: 'Choose the session duration',
		consultationLimit: 'Consultation limit is based on the student’s plan',
		hintMessage: 'Next available 90-minute consultation is after {{date}}',
		unpurchasedModal: {
			welcome: '👋 Welcome to Campus!',
			intro:
				'We’re happy to have you here. Our manager will contact you shortly to guide you through the first steps.',
			message: 'In the meantime, feel free to explore the platform !',
		},
		campus: {
			welcome: '👋 Welcome to the Campus platform!',
			intro: 'To get started, please book an introductory consultation with our methodologist.',
			goTo: 'Go to the',
			timeMeeting: 'section and pick a convenient time for the meeting.',
			bookButton: 'Book a consultation',
		},
		selfPacedModal: {
			welcome: '🚀 Time to take action!',
			intro:
				'Your journey starts now. The first lessons are already available in the “Programs” section — jump in and get started!',
			bookButton: '🔘 Go to Programs',
		},
		consultationModal: {
			successTitle: '👍 You’ve successfully booked your first consultation!',
			successMessage:
				'The next step is your second consultation, which should take place 7 days after the first one. This session will help define your learning path and give you personalized recommendations.',
			successMessageSelfPaced:
				'The meeting link is already available in the consultation card and has also been sent to your email.',
			reminder: '📅 You can book it now to secure a convenient time in advance.',
			reminderSelfPaced: 'Looking forward to seeing you there!',
		},
		googleCalendarMeetTitle: 'Talented consultation',
	},
	appointment: {
		main: 'Appointment',
		lyceum: 'Appointment',
		talented: 'Consultations',
		chooseAProgram: 'Choose a program',
		chooseATeacher: 'Choose a teacher',
		missedLesson: 'Missed lessons: {{count}}',
		location: 'Location',
		group: 'Grade',
		program: 'Subject',
		teacher: 'Teacher',
		timeZone: 'The work schedule is displayed in Kyiv time',
		visualGuide: {
			sectionDescription: 'This section will help you reduce the number of missed classes.',
			usefulInfo: "It's useful to know about reworking:",
			sessionDuration: 'Duration of 1 practice session: 30 minutes.',
			sessionFormat: 'Format: online.',
			bookingSteps: 'Follow the steps below to record:',
			selectTeacher: 'Select a teacher from the list',
			selectWeek: 'Select the day in the calendar when you want to sign up for work',
			bookSlot:
				'Book a convenient day and time in your calendar in the spaces labeled “Free”. This means that this time is available for booking. As soon as you fill in the information, you will notice an updated status and a different color of your reservation',
			note: 'Please note ',
			bookingRestriction:
				'that 🔐 next to “Free” means that the reservation is not possible because there are less than 12 hours left before the desired time.',
			sessionLinkInfo:
				'The link to the reworking will be available in the space of the time you booked: click on it again to get the data to join.',
		},
		lyceumVisualGuide: {
			sectionDescriptionTitle:
				'We are always open to communication and understand how important it is for you to have the opportunity to talk with the Lyceum team at a time that is convenient for you ',
			sectionDescription:
				'This section is your reliable tool for scheduling meetings with Lyceum representatives: choose a convenient time and teacher, and receive support exactly when you need it 😊',
			usefulInfo: "It's useful to know about meetings:",
			sessionDuration: 'Duration of 1 meeting: 20 minutes.',
			selectSubject: 'Select a subject from the list',
			selectTeacher: 'Next, select a teacher from the list',
			selectWeek: 'Select the day on the calendar when you would like to make an appointment',
			sessionLinkInfo:
				'The link to the meeting will be available in the space of the time you booked. Click on it again to get the data to join.',
			meetingSuccessMessage:
				'We wish you a smooth booking process and valuable, productive meetings!',
		},
		googleCalendarTooltip: {
			title: 'Don`t miss your session',
			message: 'Add this event to your Google Calendar and get a reminder right on time.',
			cta: 'Add to Google Calendar',
		},
		youWantToCancel: 'Are you sure you want to cancel the appointment?',
		confirmCancelAppointment: 'Yes, cancel appointment',
		rejectCancelAppointment: 'No, go back',
		wait: 'Wait,',
	},
	talented: {
		visualGuide: {
			sectionDescription:
				'This section is your reliable assistant in scheduling meetings and consultations with a career guidance specialist, who will help you choose a convenient date and time.',
			usefulInfo: 'Useful about consultations:',
			sessionDuration: 'Consultation duration: from 30 minutes to 1 hour 30 minutes',
			sessionFormat: 'Format: online via Zoom',
			bookingSteps: 'To make a booking, follow these steps:',
			selectTeacher:
				'Select any available time marked as "Free". Use the calendar to view other dates.',
			selectWeek:
				'Make sure the selected time and consultation duration are correct. Enter your phone number and click "Book".',
			bookSlot:
				'Your booked time will be highlighted in green on the calendar. Click on it to view the details and access the meeting link. The mentor will join on the selected date and time.',
			note: 'Note, ',
			bookingRestriction:
				'please, that 🔐 next to “Free” means that booking is not possible because there are less than 12 hours left before the desired time.',
			sessionLinkInfo:
				'The link to the consultation will be available in the time slot you booked: click it again to get the join details.',
		},
		orderNotification: {
			title: '🔒 Program unavailable',
			message: 'This program is locked because it hasn’t been purchased.',
		},
	},
	gradeBook: {
		lesson: 'Lesson',
		present: 'Present',
		absent: 'Absent',
		late: 'Late {{time}} min',
		online: 'Online',
		classWork: 'Class work',
		join: 'Join',
		homeWork: 'Assignment',
		homeTask: 'Assignment',
		ht: 'H/T',
		grades: 'Grades',
		assesmentType: 'Assessment type',
		tisChange: 'You’re accessing a Toronto Imperial School lesson. Would you like to switch?',
		tisChangeButton: 'Let’s gooo',
		comment: 'Comment',
		emptyTitle: "You don't have any lessons planned for this period",
		emptyDescription: 'Consider practicing your skills ',
		thematicGrade: 'Thematic grade{{label}}',
		selectProgramTitle: 'Select Program',
		selectProgramDescription: 'Select a program to see the grades',
		noGradesTitle: 'No Grades',
		noGradesDescription: 'No grades for the selected period',
		calendarView: 'Calendar view',
		teacherLeftComment: 'Teacher left commentar',
		emptyDay: 'No school today. Enjoy some well-deserved rest!',
		today: 'Today',
	},
	gradeBreakDown: {
		showWeekend: 'Show weekend',
	},
	home: {
		main: 'Home',
		greeting: 'Hello, {{name}}!',
		greetingFallback: 'Hello!',
	},
	routes: {
		access: 'Access',
		auth: 'Authorization',
		home: 'Home',
		news: 'News',
		resources: 'Resources',
		programs: 'Programs',
		lessons: 'Lessons',
		report: 'Report',
		certificates: 'Certificates',
		achievements: 'Achievements',
		about: 'About Me',
		strengths: 'Strengths',
		goals: 'Goals',
		steps: 'Steps',
		create: 'Create',
		portfolio: 'Portfolio',
		individuality: 'Individuality',
		interests: 'Interests',
		qualities: 'Personal Qualities',
		appointments: 'Appointments',
		profile: 'Profile',
		gradebook: 'Gradebook',
		month: 'Month',
		chat: 'Chat',
		homework: 'Homework',
		policies: 'Policies',
		market: 'Market',
		payment: 'Payment',
		onboarding: 'Onboarding',
		tests: 'Tests',
		dashboard: 'Dashboard',
		education: 'Education',
		financial: 'Financial',
		students: 'Students',
		b2b: 'B2B',
		results: 'Results',
		resetPassword: 'Reset Password',
	},
	profile: {
		main: 'Profile',
		parents: 'Parents',
		location: 'Location',
		class: 'Class',
		language: 'Language',
		changePassword: 'Change password',
		resetPassword: 'Reset password',
		changePasswordNotification: 'The new password has been saved',
		currentPasswordPlaceholder: 'Enter the current password',
		newPasswordPlaceholder: 'Enter the new password',
		repeatNewPasswordPlaceholder: 'Repeat the new password',
		emailPlaceholder: 'E-mail*',
		maxSizeAvatarError: 'File size exceeds {{size}}MB limit',
		typeAvatarError: 'Only image files are allowed',
		clickOrDrop: 'Click to download or drag and drop the file here',
		dropFile: 'Drop file to upload',
		english: 'English',
		ukrainian: 'Ukrainian',
		information: 'Information',
		myParents: 'My parents',
	},
	themeModal: {
		title: 'Theme settings',
		youAreResponsible:
			'You are responsible for changing the subject; if it makes learning more difficult, use a default theme.',
		concentration: 'Concentration',
		space: 'Space',
		image: 'Loading image',
		changeBanner: 'Changing a banner',
		gradient: 'Gradient',
		main: 'Main',
		text: 'Text',
		reset: 'Reset to default',
	},
	notifications: {
		main: 'Notifications',
		important: 'Important',
		empty: 'There are no notifications',
		individual: 'Individual',
		general: 'General',
		markAllAsRead: 'Mark all as read',
	},
	chat: {
		main: 'Chat',
	},
	homeWork: {
		main: 'Home work',
		emptyDataTitle: 'No homework assigned',
		emptyDataSubTitle: 'It looks like there are no homework assignments for the selected period',
		emptyDataSubTitleForWeek: 'It looks like there are no homework assignments for the next 7 days',
		lessonTopic: 'Lesson Topic',
		nextLesson: 'Next lesson {{date}}',
		homeworkStatus: 'Homework status',
		new: 'New',
		inProgress: 'In progress',
		checking: 'Under assessment',
		done: 'Done',
		seeAll: 'See all',
		overdue: 'Overdue',
	},
	policies: {
		main: 'Policies',
		emptyDataTitle: 'There are no policies',
	},
	errorPage: {
		subTitle: '',
		goToPrograms: 'Go to Programs',
		goToNews: 'Go to News',
		newVersionAvailable: 'A new version is available. Page reloading...',
	},
	shared: {
		viewResult: 'View result',
		copyLink: 'Copy link',
		moreOption: 'More option',
		shareViaEmail: 'Share via email',
		rememberMe: 'Remember me',
		childAccount: "Child's account",
		schoolAdministration: 'School administration',
		back: 'Back',
		todo: 'To do',
		complete: 'Complete lesson',
		sortBy: 'Sort by',
		comingSoon: 'Coming soon...',
		latest: 'Latest',
		addFile: 'Add File',
		save: 'Save',
		submit: 'Submit lesson',
		submitTest: 'Submit',
		logout: 'Logout',
		success: 'Success!',
		day: 'Day',
		week: 'Week',
		emptyDataTitle: "We're working on adding content.",
		emptyDataSubTitle: 'Everything will be available soon!',
		cancel: 'Cancel',
		cancelCaps: 'CANCEL',
		delete: 'Delete',
		areYouSure: 'Are you sure ?',
		youWantToDelete: 'You want to delete this file',
		somethingWentWrong: 'Something went wrong',
		tutorial: 'Tutorial',
		loading: 'Loading...',
		notifications: {
			default: 'Notification',
			success: 'Success!',
			error: 'Error!',
			warning: 'Warning!',
			info: 'Information',
		},
		days: {
			one: 'Day',
			few: 'Days',
			many: 'Days',
		},
		hours: {
			one: 'Hour',
			few: 'Hours',
			many: 'Hours',
		},
		minutes: {
			one: 'Minute',
			few: 'Minutes',
			many: 'Minutes',
		},
		seconds: {
			one: 'Second',
			few: 'Seconds',
			many: 'Seconds',
		},
		date: 'Date',
		theme: 'Theme',
		subject: 'Subject',
		deadlineUntil: 'Deadline {{date}}',
		deadlineWas: 'Due date {{date}}',
		confirm: 'Confirm',
		confirmCaps: 'CONFIRM',
		verifyYourself: 'Verify yourself',
		refresh: {
			button: 'Refresh',
			message: 'A new version is available',
		},
		send: 'Send',
		phone: 'Phone number',
		email: 'Email address',
		fullName: 'Full Name',
		start: 'Start',
		dashboard: 'Dashboard',
		review: 'Review',
		action: 'Action',
		noData: 'NO DATA',
		search: {
			placeholder: 'Name, ID, etc...',
			label: 'Search',
		},
		pagination: {
			rowsPerPage: 'Rows per page:',
		},
		columns: {
			studentName: 'Student name',
			emailAddress: 'Email address',
			grade: 'Grade',
			englishTest: 'English test',
			talanted: 'Talanted ',
			action: 'Action',
			status: 'Status',
			group: 'Group',
			program: 'Program',
			loa: 'LOA',
		},
		filters: {
			default: 'FILTERS',
		},
		applyCaps: 'APPLY',
		resetCaps: 'RESET',
		seeMore: 'See more',
		sendTestPush: 'Send test push (next7)',
		testPushSent: 'Test push sent',
		pushTokenUpdated: 'Push token updated',
	},
	auth: {
		selectChildAccount: "Select the child's account",
	},
	tabs: {
		aboutMe: 'ABOUT ME',
		achievement: 'ACHIEVEMENT',
		allLessons: 'ALL LESSONS',
		todo: 'ASSIGNED',
		active: 'ACTIVE',
		onChecking: 'UNDER ASSESSMENT',
		renew: 'RENEW',
		completed: 'GRADED',
		books: 'BOOKS',
		materials: 'MATERIALS',
		gradebook: 'GRADEBOOK',
		gradeBreakdown: 'GRADE BREAKDOWN',
		classWork: 'CLASSWORK',
		homeWork: 'HOMEWORK',
		details: 'DETAILS',
		teacherComment: 'TEACHER FEEDBACK',
		pdfReport: 'PDF REPORT',
	},
	validationMessages: {
		selectOneOption: 'Select one option',
		onlyOneOption: 'Only one option can be selected',
		selectAtLeastOne: 'Select at least one option',
		passwordsNotMatch: 'Passwords not match',
		mandatory: 'Field is mandatory',
		fileRequired: 'Need to add a file',
		passwordMatch: 'Passwords must match',
		minCharacters: {
			one: 'The password must be at least {{min}} characters',
			few: 'The password must be at least {{min}} characters',
			many: 'The password must be at least {{min}} characters',
		},
		lowercaseLetter: 'The password must contain at least one lowercase letter',
		uppercaseLetter: 'The password must contain at least one capital letter',
		invalidEmail: 'Please enter a valid email address',
		passwordMin: 'Password must be at least 4 characters',
		login: {
			invalidEmail: 'Invalid email address',
			passwordMin: 'Password must be at least 8 characters',
		},
		confirmPassword: {
			passwordMin: 'Password must be at least 4 characters',
			passwordsMustMatch: 'Passwords must match',
		},
	},
	b2b: {
		studyPrograms: 'Study programs',
		tuitionFees: 'Tuition & Fees',
		freePrograms: 'Free Programs',
		dashboard: 'Dashboard',
		education: 'Education',
		financial: 'Financial',
		commissionStructure: 'Commission Structure',
		students: 'Students',
		contactUs: 'Contact us',
		writeToUs: 'Write to us in the chat',
		free: 'Free',
		payment: 'Fees & tuition',
		all: 'All',
		contactWithUs: 'Contact with us',
		constUsModalDescription:
			'Leave your phone number, and our specialist will give you a <highlight>free consultation</highlight> to help you find the perfect option just for you.',

		partnersPathway: {
			title: 'Partner Pathway to Success',
			step: 'Step',
		},
		onboardingHub: {
			title: 'Onboarding hub',
			step1Title: 'Certificate & Memorandum',
			step1Description: 'Get certified and offer exclusive student benefits',

			step2Title: 'Education Program',
			step2Description: 'Step-by-step plan with tools and examples for easy learning',

			step3Title: 'Financial Motivation',
			step3Description: 'Earn commission for every student you bring',

			step4Title: 'Start By Inviting Students',
			step4Description: 'Invite students to join courses and start learning',

			step5Title: 'Launch Your First Group',
			step5Description: 'Step-by-step plan with tools and examples for easy learning',

			getIt: 'Get it',
			detail: 'Detail',
			step: 'Step',
		},
		video: {
			title: 'Video',
		},
		profile: {
			aboutMe: 'About me',
			firstName: 'First name',
			lastName: 'Last name',
			emailAddress: 'Email address',
			phoneNumber: 'Phone number',
			country: 'Country',
			city: 'City',
			institutionName: 'Name of the institution',
			institutionType: 'Type of institutions',
			memorandum: 'Partnership Memorandum of Understanding (MOU)',
			officialPartnershipCertificate: 'Partnership Certificate',
			teacherCertificate: 'Teacher Certificate',
			certificate: 'Certificate',
			b2bTestCompletionCertificate: 'Certificate of completion the English language test',
		},
		documents: { default: 'Documents' },
		welcomeModal: {
			title: 'Welcome to the Toronto Imperial School Partner Platform!',
			description:
				'We’re glad to have you on board.<br /><br />This platform is designed to guide you through the key steps every partner needs to complete. You’ll find everything you need to understand our programs, access essential resources, and get ready to start working with families and students.<br /><br />Let’s get started!',
			button: 'Get started',
		},

		launchModal: {
			title: '🎓 Launch of Your First Training Group',
			description:
				'Congratulations — you’re almost there!<br />Your first student group is about to begin.<br /><br />On this page, you’ll find everything you need:<br />✔️ Launch materials<br />✔️ Support from the TIS team<br />✔️ Steps to guide your students<br /><br />Ready to inspire and earn?<br />Click "Get Started" below and let’s begin your journey!<br />',
			button: 'Get started',
		},
		memorandum: {
			title: 'Partnership Memorandum',
			whatIsTitle: 'What Is the Partnership Memorandum?',
			whatIsDescription:
				'The Partnership Memorandum is a simple, non-binding document that outlines your interest in academic cooperation with Toronto Imperial School through the TIS platform.<br /> It does <b>not</b> create any legal, financial, or administrative obligations.',

			whyImportantTitle: 'Why It’s Important',
			whyImportantDescription: 'By accepting the principles of this memorandum, your institution:',

			whyImportantList: {
				item1: 'Can offer tests and diagnostics to your students',
				item2: 'Gains access to consultations, workshops, and webinars with TIS-certified staff',
				item3: 'Unlocks exclusive academic tools, early-bird offers, and promotions',
				item4: 'Receives priority support and onboarding from the TIS team',
			},

			footer: 'No fees. No formalities. Just opportunities to grow together.',
		},
		partnerAcknowledgementCertificate: {
			title: 'Congratulations!',
			line1: "You've received the official Partner Certificate from Toronto Imperial School",
			line2:
				'You are now officially authorized to represent the school and best offers to your students as a certified partner.',
			line3: 'Your certificate is stored in your personal dashboard.',
			line4:
				'You can download or present it anytime upon request. This certificate confirms your trusted status and professional recognition.',
		},
		teacherCertificate: {
			title: 'This is your certificate of program completion.',
			line1: 'It is issued in your name and confirms your successful participation.',
			line2: 'You can view it online or download it as a PDF.',
		},
		financialPage: {
			title: 'Financial Model: Volume-Based Commission',
			intro:
				'At Toronto Imperial School, we work with our partners using a Volume-Based Commission Model. This approach is transparent, flexible, and encourages long-term cooperation.',
			b2cTitle:
				'<t>B2C Price</t> - the full program price paid by the student. This is the price you advertise to your clients.',
			b2bTitle:
				'<t>B2B Price</t> - the amount your organization pays to Toronto Imperial School after subtracting your commission.',
			howItWorksTitle: 'How It Works',
			howItWorksDescription:
				'The more students you enroll, the higher your commission is. Students Enrolled Partner Commission (from B2C price)',
			row0: '1–4 students',
			row1: '5–10 students',
			row2: '11–30 students',
			row3: '30+ students',
			commissionNote: 'Your commission is calculated from the B2C price.',
			commissionNoteSecond: 'You keep the commission, and pay us the B2B price.',
			exampleTitle: 'Example: You teach Program',
			exampleText1: 'If the B2C price is 970 CAD per student, you earn:',
			exampleText0: '145 CAD per student with 15% commission',
			exampleText2: '290 CAD per student with 30% commission',
			exampleText3: '340 CAD per student with 35% commission',
			exampleText4: '440 CAD per student with 40% commission',
			whyItWorksTitle: 'Why This Model Works',
			why1: 'Clear and simple structure — no hidden fees or confusion',
			why2: 'Performance-based rewards — the more you grow, the more you earn',
			why3: 'Flexible for any partner type — works for schools, agencies, tutors, or individual educators',
			why4: 'Scalable across programs — available for OSSD, Pre-OSSD, UFT',
			contactNote: 'If you have any questions, feel free to contact your Partner Support Manager.',
			table: {
				title: 'Let’s Grow Together: Plans & Commissions',
				note: '*Please note that every participant of the program is subject to a registration fee of 140 CAD',
				gotQuestion: 'Got questions?',
				answer: 'Click the button below and leave your request — we’re here to help!',
				button: 'Leave a Request',
				program: 'Program',
				volume: 'Volume',
				duration: 'Course duration',
				b2cPrice: 'B2C price',
				commission: 'Commission',
				b2bPrice: 'B2B price',
				ossdTeacher: 'OSSD teacher-led',
				ossdSelf: 'OSSD self-paced',
				preOssd: 'Pre-OSSD with teacher',
				career: 'Career Desing',
				group: 'group',
				individual: 'individual',
			},
		},
		studentsPage: {
			addStudent: 'Add students',
			modalMessage: 'Or share a quick registration link:',
			uniqueLink: 'Create a unique link to share access.',
			copiedAndSent: 'It can be copied and sent in any convenient way.',
			generateLinks: 'Generate links',
		},
		talented: {
			notification: {
				title: 'Message:',
				welcome: 'Welcome to the Talented platform!',
				message:
					'Here you will find the main information about working with Talented. You can also create student invitations, track student progress, and view student profiles.',
			},
			onboardingHub: {
				step1Title: 'Certificate and Memorandum',
				step1Description: 'Receive your partnership certificates',

				step2Title: 'Training Programs',
				step2Description: 'Explore free and paid products',

				step3Title: 'Financial Motivation',
				step3Description: 'Learn about bonuses and commissions',

				step4Title: 'Student Invitations',
				step4Description: 'Create individual links for tests',

				step5Title: 'Launching Your First Group',
				step5Description: 'Start teaching together with Talented',

				getIt: 'Get it',
				detail: 'More details',
			},
			documents: {
				memorandum: 'Memorandum of Intent',
				partnerCertificate: 'Partner Certificate',
				teacherCertificate: 'Facilitator / Mentor / Instructor Certificate',
				b2bPresentation: 'B2B Presentation',
			},
		},
		events: {
			default: 'Events',
		},
	},
	media: {
		preview: 'Preview',
		play: 'Play',
		dropToUpload: '<FileUploadTextPrimary>Drop file</FileUploadTextPrimary> to upload',
		clickToUpload:
			'<FileUploadTextPrimary>Click to upload</FileUploadTextPrimary> or drag and drop',
		formatPdf500: 'PDF (max. 500MB)',
		formatImageDefault: 'SVG, PNG, JPG or GIF (max. 3MB)',
		formatChunkFile: 'Image, PDF, Office package (max. 100MB)',
		formatChunkScorm: 'Scorm file (max. 762.94MB)',
		formatVideo500: 'Video File (max. 500MB)',
	},
	common: {
		chat: {
			rules: 'Rules',
			continue: 'Continue',
		},
	},
	tests: {
		default: 'Tests',
		signup: {
			welcome: 'Welcome!',
			message: 'Before you begin your practice test, please complete a quick registration.',
			startTest: 'Start test',
		},
		cta: {
			submit: 'Submit {{slideName}}',
			submitting: 'Submitting...',
			startTest: 'Start test',
		},
		time: 'Time',
		test: 'Test',
		modal: {
			title: '📝 A test is available for you {{testName}}',
			message:
				'A new test is available for you. Take a moment to focus and get ready — it won’t take long',
			cta: 'Start the test',
		},
		modalIELS: {
			title: '{{testName}} is available! 🎉',
			p1: 'The test will begin <bold>immediately</bold> after you click the <bold>"Start"</bold> button.',
			p2: "On the first page, please take a moment to carefully review the test instructions and details — you'll find all the important rules ✅",
			p3: 'If you would like to take the test later, simply click the X in the top-right corner. You can return to the test at any time before the deadline by clicking the blue flag on the right side of the screen.',
			p4: 'Good luck ✊🏻✨',
			cta: 'Start the test',
		},
		thankYouPage: {
			title: 'Thank you for completing the test!',
			message1: 'Your answers have been submitted successfully.',
			message2: 'You will receive your results shortly.',
			pro: {
				welcome: 'Welcome, <strong>{{userName}}</strong> 👋',
				yourRIASECResluts: 'Your RIASEC Results',
				note: '<strong>Note:</strong> The test results reflect your current state, responses, and mood at the time of taking the test. They are indicators of your inclinations and interests, but they do not define a specific profession or specialty. <br /><br /> Keep in mind that these results can be applied across different fields and areas of activity. They serve as a guide to understanding your strengths and potential, which can be realized in many professional domains.',
				takeReport: 'Take your report with you — one click and the PDF is ready.',
				downloadThePdf: 'Download the PDF',
			},
		},
		results: 'Test results',
		resultsReview: {
			yourLevel: 'Your level',
			studentCurrentLevel: 'Student current level',
			recommendedLevel: 'Recommended level',
			yourCertificate: 'Your certificate',
			greatJob:
				'Great job - you`ve reached {{levelShortName}}, an {{levelLongName}} level of English.',
			nextStep: "You're ready for the next step — Level {{levelShortName}}!",
			nextLearningPath: 'We’ve already prepared your next learning path.',
			nextLearningPathDescription:
				'New lessons, practice activities, and challenges are waiting for you. Let’s boost your vocabulary, grammar, and fluency together.',
			cta: 'Start your {{levelShortName}} journey now',
			certificate: 'Certificate',
			congratulations: '🎉 Congratulations!',
			certificateSectionText:
				"You've successfully completed the English level test. Want to prove your result? Get your personalized certificate and showcase your skills with confidence!",
			completionOfAssessment: 'Completion of Assessment – Level {{level}}',
			completionOfAssessmentTest:
				'Great news! This student has completed the required steps and unlocked new programs.',
			seeCertificate: 'See certificate',
			getCertificateCta: 'Get My Certificate',
			personalizeModal: {
				title: 'Personalize',
				text: "To personalize your certificate, please enter your full name as you'd like it to appear.",
			},
			programProposition: {
				title: 'Program proposition',
				name: 'Name',
				cost: 'Cost',
				yourCommission: 'Your commission',
			},
			resultsAnalysis: 'Results analysis',
			certificateModal: {
				title: 'Congratulations!',
				text: 'You’ve successfully completed the <strong>Placement Test</strong> with <strong>Toronto Imperial School</strong> — well done!</br></br> This is your <strong>first step toward international academic success</strong>, and we’re excited to be part of your journey. Your certificate is now available in the <strong>“Documents”</strong> section of your personal dashboard.</br></br> We’re here to guide and support you every step of the way.</br></br> Let’s move forward together! ',
			},
		},
		alreadyRegisteredEmailModal: {
			title: '🔔 This email is already registered',
			text1:
				'It looks like there’s already an account associated with this email. We’ve sent a message with a test link to your inbox.',
			text2: 'If you’d like to create a new account, please use a different email address.',
		},
	},
};

export default LANGUAGE_FILE_EN;

export type LanguageResourse = typeof LANGUAGE_FILE_EN;

export type LanguageTranslationKeys = DeepKeys<typeof LANGUAGE_FILE_EN>;
